import { render, staticRenderFns } from "./ShopExpand.vue?vue&type=template&id=21815cf2&scoped=true"
import script from "./ShopExpand.vue?vue&type=script&lang=js"
export * from "./ShopExpand.vue?vue&type=script&lang=js"
import style0 from "./ShopExpand.vue?vue&type=style&index=0&id=21815cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21815cf2",
  null
  
)

export default component.exports